import { LocalizationManager } from "../localization/localization_manager.js";
import type { OfferDto } from "../api/dto/offers.dto.js";

/**
 * Maps the server-declared `visual` of an offer to the client preset that
 * draws it, the way placement_offer_registry does for placement templates.
 * The server validates that a visual exists for the offer's presentation and
 * shop section; this file decides what each one looks like. An offer without
 * a visual keeps the legacy behaviour, where the card style was picked by the
 * offer's position in the list, so the catalog can be migrated one offer at a
 * time without a client release in between.
 */

export function offerTitleKey( offer: OfferDto, fallback: string ): string
{
  return offer.texts?.title_key ?? fallback;
}

export function offerDescriptionKey( offer: OfferDto, fallback: string ): string
{
  return offer.texts?.description_key ?? fallback;
}

export function offerLocalizedText(
  configured_key: string | undefined,
  fallback_key: string,
  fallback_text: string,
  params: readonly string[] = [],
): string
{
  for ( const key of [ configured_key, fallback_key ] )
  {
    if ( !key ) continue;
    const text = params.length ? LocalizationManager.tWithParams( key, params ) : LocalizationManager.t( key );
    if ( text !== key ) return text;
  }
  return params.reduce( ( acc, value, index ) => acc.split( `{${index}}` ).join( value ), fallback_text );
}

/** Button copy for offers whose button is not the store price (free claims, dialogs). */
export function offerButtonLabel( offer: OfferDto, fallback: string ): string
{
  return offer.texts?.button_key ? LocalizationManager.t( offer.texts.button_key ) : fallback;
}
